import { render, staticRenderFns } from "./LegalMentions4xCb.vue?vue&type=template&id=1d5c9245&"
import script from "./LegalMentions4xCb.vue?vue&type=script&lang=js&"
export * from "./LegalMentions4xCb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d5c9245')) {
      api.createRecord('1d5c9245', component.options)
    } else {
      api.reload('1d5c9245', component.options)
    }
    module.hot.accept("./LegalMentions4xCb.vue?vue&type=template&id=1d5c9245&", function () {
      api.rerender('1d5c9245', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/components/LegalMentions4xCb.vue"
export default component.exports